import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./OfertasDaSemana.css";

import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";

import Imagens from "../../components/IMAGESCOMPONENT/ImageComponent";

export default function OfertasDaSemana() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Banners
  const [banners, setBanners] = useState([]);
  const [loadingBanners, setLoadingBanners] = useState(true);

  // Produtos
  const [produtos, setProdutos] = useState([]);
  const [loadingProdutos, setLoadingProdutos] = useState(true);

  // Título dinâmico
  const [tituloOfertas, setTituloOfertas] = useState(null);
  const [loadingTitulo, setLoadingTitulo] = useState(true);

  /* =======================
     BANNERS
  ======================= */
  useEffect(() => {
    async function carregarBanners() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/home_media/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setBanners(data);
      } catch (error) {
        console.error("Erro ao buscar banners:", error);
      } finally {
        setLoadingBanners(false);
      }
    }

    carregarBanners();
  }, []);

  const bannerOfertas = banners.find(
    (banner) => banner.localizacao === "ofertasdasemana" && banner.ordem === 1
  );

  /* =======================
     PRODUTOS + IMAGENS
  ======================= */
 useEffect(() => {
  async function carregarProdutosOfertas() {
    try {
      // 1️⃣ Buscar coditems das ofertas
      const resCod = await fetch(
        "https://app.eliandroalimentos.com.br/api/produtos_destaque/listar-produtos-ofertasdodia"
      );
      const codData = await resCod.json();
      

      // 2️⃣ Filtrar apenas os da localização "ofertasemana"
      const codFiltrados = codData
        .filter(item => item.localizacao === "ofertasemana")
        .map(item => item.coditem);

      // Se não tiver nenhum produto, encerra
      if (codFiltrados.length === 0) {
        setProdutos([]);
        setLoadingProdutos(false);
        return;
      }

      // 3️⃣ Buscar dados dos produtos
      const resProdutos = await fetch(
        "https://app.eliandroalimentos.com.br/api/busca/buscar-por-coditem",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ coditems: codFiltrados }),
        }
      );

      const produtosData = await resProdutos.json();

      // 4️⃣ Buscar imagem INDIVIDUAL de cada produto
      const produtosComImagem = await Promise.all(
        produtosData.map(async (produto) => {
          try {
            const resImg = await fetch(
              "https://app.eliandroalimentos.com.br/api/produtos/retornaimagemproduto",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ coditem: produto.CodItem }),
              }
            );

            const imgData = await resImg.json();

            return {
              ...produto,
              imagem: imgData?.imagem
                ? `data:image/bmp;base64,${imgData.imagem}`
                : null,
            };
          } catch (err) {
            console.error("Erro ao buscar imagem:", produto.CodItem);
            return { ...produto, imagem: null };
          }
        })
      );

      setProdutos(produtosComImagem);
    } catch (error) {
      console.error("Erro ao carregar produtos:", error);
    } finally {
      setLoadingProdutos(false);
    }
  }

  carregarProdutosOfertas();
}, []);


  /* =======================
   TÍTULO
======================= */
  useEffect(() => {
    async function carregarTitulo() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/titulos/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );

        const data = await response.json();

        const titulo = data.find(
          (item) => item.localizacao === "ofertasdasemana"
        );

        setTituloOfertas(titulo);
      } catch (error) {
        console.error("Erro ao buscar título:", error);
      } finally {
        setLoadingTitulo(false);
      }
    }

    carregarTitulo();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  /* =======================
     RENDER
  ======================= */
  return (
    <>
      <Navbar />
      <TopLinks onOpenMenu={() => setMenuOpen(true)} />
      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      {/* BANNER */}
      <section className="ofertasemana-banner">
        {!loadingBanners && bannerOfertas && (
          <img src={bannerOfertas.imagem} alt="Banner Ofertas da Semana" />
        )}
      </section>

      {/* BREADCRUMB */}
      <div className="ofertasemana-link-left">
        <a href="/" className="ofertasemana-breadcrumb-link">
          Início
        </a>
        <span className="ofertasemana-breadcrumb-separator">›</span>
        <div className="ofertasemana-breadcrumb-current">Ofertas Da Semana</div>
      </div>

      <div className="ofertasemana-wrapper">
        <section className="ofertasemana-title">
          {!loadingTitulo && tituloOfertas && (
            <h1>{tituloOfertas.descricao}</h1>
          )}
        </section>

        {/* PRODUTOS */}
        <section className="ofertasemana-products">
          {loadingProdutos && <p>Carregando produtos...</p>}

          {!loadingProdutos &&
            produtos.map((produto) => (
              <div className="ofertasemana-product-card" key={produto.CodItem}>
                <img
                  src={produto.imagem || Imagens.Produto1}
                  alt={produto.Descricao}
                />

                <div className="ofertasemana-produto-meta">
                  {produto.pesob} Kg - Cód. {produto.CodItem}
                </div>

                <h3>{produto.Descricao}</h3>

                <button
                  onClick={() => navigate(`/cardproduto/${produto.CodItem}`)}
                >
                  Ver produto
                </button>
              </div>
            ))}
        </section>
      </div>

      <BTNtoTop />
      <Footer />
    </>
  );
}
